import React, { Component } from 'react';

import LoginComponent from '../components/login';

export default class Login extends Component {
    render() { 
        const {...props} = this.props
        return (
            <div className='login-root'>
                <div className='bg-login'>
                    <div className='img-inside'></div>
                </div>
                <LoginComponent {...props} />
            </div>
        )
    }

}

